var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"试验结果","disabled":_vm.disabled},model:{value:(_vm.value_temp),callback:function ($$v) {_vm.value_temp=$$v},expression:"value_temp"}},[_c('el-option',{attrs:{"value":"合格"}}),_c('el-option',{attrs:{"value":"不合格"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }